<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('studentList.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        {
          text: $t('studentList.pageTitle'),
          active: true
        }
      ]" />
    </div>
    <div class="row">
      <div class="col-md-3">
        <ts-card>
          <ts-card-wrapper>
            <ts-loading-banner :loading="loading">
              <form>
                <fieldset>
                  <legend>{{ $t('studentList.criteria') }}</legend>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('cashCollectionByCashier.branchName')
                      }}</label>
                      <a-select style="width: 100%" v-model.number="model.branch_id" :options="branches"></a-select>
                      <div class="validate" v-if="errors.has('branch_id')">
                        {{ errors.first('branch_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('studentList.acYear')
                      }}</label>
                      <a-select style="width: 100%" v-model.number="model.ac_year_id" :options="ac_year_list"
                        @change="acYearChange"></a-select>
                      <div class="validate" v-if="errors.has('ac_year_id')">
                        {{ errors.first('ac_year_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('studentList.subProgram')
                      }}</label>
                      <a-select style="width: 100%" v-model.number="model.acps_id" :options="sub_programs"
                        :show-search="true" :filter-option="(input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          " @change="onSubChange" :disabled="!model.ac_year_id"></a-select>
                      <div class="validate" v-if="errors.has('acps_id')">
                        {{ errors.first('acps_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('studentList.acTerm')
                      }}</label>
                      <a-select style="width: 100%" v-model.number="model.ac_term_id" :options="ac_terms"
                        :show-search="true" :filter-option="(input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          " @change="acTermChange"></a-select>
                      <div class="validate" v-if="errors.has('ac_term_id')">
                        {{ errors.first('ac_term_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>{{ $t('studentList.classOperation') }}</label>
                      <a-select style="width: 100%" v-model="model.class_id" :options="class_options" :show-search="true"
                        :placeholder="$t('all')" :limit="1" mode="multiple" :filter-option="(input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          "></a-select>
                      <div class="validate" v-if="errors.has('class_id')">
                        {{ errors.first('class_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>{{ $t('studentList.deptMoeys') }}</label>
                      <input type="text" class="form-control" v-model="model.dept_moeys" />
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>{{ $t('inactiveStudent.status') }}</label>
                      <treeselect :options="studentStatus.map(i => ({
                        id: i.status_id,
                        label: i.status
                      }))
                        " :placeholder="$t('all')" :multiple="true" :limit="1" v-model="model.status_id"></treeselect>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label>{{ $t('studentList.reportType') }}</label>
                      <div class="form-group">
                        <div class="radio radio-css radio-inline">
                          <input v-model="model.report_type" type="radio" id="en" :value="'en'" />
                          <label for="en"> {{ $t('report.english') }} </label>
                        </div>
                        <div class="radio radio-css radio-inline">
                          <input v-model="model.report_type" type="radio" id="kh" :value="'kh'" />
                          <label for="kh">{{ $t('report.khmer') }} </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 text-right">
                      <ts-button class="btn-block" outline color="success" @click.prevent="exportExcel"
                        :waiting="exporting">{{ $t('excel') }}</ts-button>
                    </div>
                    <div class="col-md-6 text-right">
                      <ts-button class="btn-block" color="primary" @click.prevent="preview" :waiting="waiting">{{
                        $t('preview') }}</ts-button>
                    </div>
                  </div>
                </fieldset>
              </form>
            </ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('studentList.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'

export default {
  name: 'studentList',
  data() {
    return {
      loading: false,
      waiting: false,
      exporting: false,
      src: '',
      errors: new Errors(),
      sub_programs: [],
      ac_terms: [],
      ac_year_list: [],
      class_options: [],
      branches: [],
      model: {
        report_type: 'en',
        branch_id: null,
        dept_moeys: '',
        acps_id: null,
        ac_term_id: null,
        ac_year_id: null,
        class_id: [],
        status_id: null
      }
    }
  },
  computed: {
    ...mapState('reportAcademic', ['studentStatus'])
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapActions('reportAcademic', [
      'getBranch',
      'studentList',
      'getSubProgram',
      'getTerm',
      'getYear',
      'getClass',
      'getStudentStatus'
    ]),
    async fetchData() {
      this.loading = true
      await this.getStudentStatus()
      await this.getBranch().then(response => {
        this.branches = response.data.map(el => ({
          value: el.branch_id,
          label: el.branch_name_en
        }))
        this.model.branch_id = this.$store.state.authUser.default_branch_id
      })
      await this.getSubProgram()
        .then(response => {
          this.sub_programs = response.data.map(el => ({
            value: el.acps_id,
            label: el.acps_name_foreign
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onBranchChange() {
      this.model.ac_year_id = null
      this.model.acps_id = []
      this.model.ac_term_id = []
      this.fetching = true
      this.getYear({
        filter: {
          ac_status_id: '1,2,3',
          branch_id: this.model.branch_id
        },
        branch_id: [this.model.branch_id]
      })
        .then(response => {
          this.ac_year_list = _.sortBy(response.data, ['ac_status_id']).map(
            el => ({
              value: el.ac_year_id,
              label:
                el.ac_year +
                (el.ac_status_id == 1
                  ? ' ( Current ) '
                  : el.ac_status_id == 2
                    ? ' ( History ) '
                    : ' ( Next ) ')
            })
          )
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching = false
        })
    },
    onSubChange(acps_id) {
      this.model.ac_term_id = null
      this.model.class_id = []
      this.loading = true
      this.getTerm({
        filter: {
          acps_id: acps_id,
          ac_status_id: '1,2,3',
          ac_year_id: this.model.ac_year_id,
          branch_id: this.model.branch_id
        },
        branch_id: [this.model.branch_id]
      })
        .then(response => {
          this.ac_terms = response.data.map(el => ({
            value: el.ac_term_id,
            label:
              el.term_name +
              (el.ac_status_id == 1
                ? ' ( Current ) '
                : el.ac_status_id == 2
                  ? ' ( History ) '
                  : '( Next )')
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    acYearChange() {
      this.model.acps_id = null
      this.model.ac_term_id = null
      this.model.class_id = []
    },
    acTermChange(ac_term_id) {
      this.loading = true
      this.getClass({
        filter: {
          ac_term_id: ac_term_id,
          branch_id: this.model.branch_id
        },
        branch_id: [this.model.branch_id]
      })
        .then(response => {
          this.class_options = response.data.map(el => ({
            value: el.class_id,
            label:
              el.class_name +
              ' | ' +
              el.teacher.full_name_en +
              ' | ' +
              el.academic_study_time.study_time
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    preview() {
      this.waiting = true
      this.src = ''
      this.errors = new Errors()
      this.studentList(this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    exportExcel() {
      this.exporting = true
      this.errors = new Errors()

      this.$store
        .dispatch('reportAcademic/studentListExcel', this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    }
  },
  watch: {
    'model.branch_id': function (val) {
      if (val) {
        this.onBranchChange()
      }
    }
  }
}
</script>
